// extracted by mini-css-extract-plugin
export default {"list":"kdagiQ","item":"lDlVAa"};